import _ from 'lodash'
import LayerGroup from './filtre_layers_group.vue';

export default {
	data() {
		return {
			opened: true
		}
	},
	props: ['params'],
	methods: {
		switchLayerOpened(i){
			this.opened = !this.opened
		}
	},
	computed:{
		isOpened(){
			return this.opened
		},
		canHeatmapPvr(){
			let can = false
			let familles = this.$store.getters.getFamillesParams;
			_.forEach(familles, function(famille){
				if(famille.pvr_metha === '1') can = true
			})
			return can
		},
		getLayers(){
			let self = this;
			let layers = [];
			_.forEach(self.params.list, function(layer){
				let __layer = false;
				_.forEach(self.$store.state.ui.layers, function(_layer){
					if(_layer.id == layer.id) __layer = _layer;
				})
				
				if(__layer != false){
					__layer.picto = 'Grid';
					__layer.nom = self.i18n(layer.title);
					__layer.force_update = true;
					layers.push(__layer)
				}
			})

			return layers;
		}
	},
	watch: {},
	components: {
		LayerGroup
	}
}